import { useTranslate } from "@similarweb/i18n-provider";

import { useTimeLeft } from "app/components/discountCampaign/DiscountBanner/hooks/useTimeLeft";

import type { ICountdownTimerTheme } from "./StyledCountdownTimer";
import { TimeBoxWrapper, TimeLabel, TimeValue, TimerContainer } from "./StyledCountdownTimer";

const TIMER_LABEL_KEYS = {
    day: "discount.popup.trial.time.day",
    days: "discount.popup.trial.time.days",
    hours: "discount.popup.trial.time.hours",
    min: "discount.popup.trial.time.min",
    sec: "discount.popup.trial.time.sec",
} as const;

export interface ICountdownTimerProps {
    discountEndTime?: string;
    theme: ICountdownTimerTheme;
}

const TimeBox = ({ time, label, theme }: { time: number | string; label: string; theme: ICountdownTimerTheme }) => (
    <TimeBoxWrapper $theme={theme}>
        <TimeValue $theme={theme}>{time}</TimeValue>
        {theme.withLabel ? <TimeLabel $theme={theme}>{label}</TimeLabel> : null}
    </TimeBoxWrapper>
);

const toPaddedNumber = (value: number): string => String(value).padStart(2, "0");

export const CountdownTimer = ({ discountEndTime, theme }: ICountdownTimerProps) => {
    const { translate } = useTranslate();
    const timeLeft = useTimeLeft({ discountEndTime });

    if (!discountEndTime) {
        return null;
    }

    return (
        <TimerContainer>
            <TimeBox
                time={toPaddedNumber(timeLeft.days)}
                label={translate(timeLeft.days === 1 ? TIMER_LABEL_KEYS.day : TIMER_LABEL_KEYS.days)}
                theme={theme}
            />
            <TimeBox
                time={toPaddedNumber(timeLeft.hours)}
                label={translate(TIMER_LABEL_KEYS.hours)}
                theme={theme}
            />
            <TimeBox
                time={toPaddedNumber(timeLeft.minutes)}
                label={translate(TIMER_LABEL_KEYS.min)}
                theme={theme}
            />
            <TimeBox
                time={toPaddedNumber(timeLeft.seconds)}
                label={translate(TIMER_LABEL_KEYS.sec)}
                theme={theme}
            />
        </TimerContainer>
    );
};
